import "./AboutHero.css";

export default function AboutHero() {
  return (
    <>
      {/* Page Banner */}
      <section
        className="page-banner"
        style={{
          backgroundImage: "url('/relyonn-warehouse.jpeg')"
        }}
      >
        <div className="banner-overlay">
          <div className="banner-content">
            <span>WHO WE ARE</span>
            <h1>Building Trust Through Quality Paper Solutions</h1>
            <p>
              Your trusted partner for premium paper, board and packaging
              products across the United Kingdom.
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-hero">
        <div className="about-image">
          <img
             src="/who-we-are.jpeg"
            alt="RelyOnne UK Limited Warehouse"
          />
        </div>

        <div className="about-content">
          <span className="section-tag">OUR STORY</span>

          <h2>
            Delivering <span>Quality</span>, Building
            <span> Relationships</span>
          </h2>

          <p>
            <strong>RelyOnne UK Limited</strong> is a UK-based supplier of paper, board and packaging materials.
          </p>

          <p>
          We source and supply a wide range of products from trusted suppliers, offering our customers competitive pricing, consistent quality and reliable availability.
          </p>

          <p>
          We work with distributors, manufacturers, printers, retailers and businesses across the UK, providing dependable supply solutions tailored to their requirements.
          </p>

          <p>
          Our focus is simple: good products, competitive prices, reliable supply and long-term relationships.
          </p>
        </div>
      </section>
    </>
  );
}